import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { hasActiveSubscription } from "../utils/subscriptionUtils";
import ChatWindow from "./ChatWindow";

const ChatVisibilityController: React.FC = () => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user.currentUser);

  // Routes where the chat button should be hidden
  const hiddenRoutes = ["/signin", "/signup", "/login", "/landing"];

  // Check if current route should hide the chat button
  const isRouteHidden = () => {
    const currentPath = location.pathname;

    // Check exact matches
    if (hiddenRoutes.includes(currentPath)) {
      return true;
    }

    // Check for routes that start with certain patterns
    const hideStartsWith = ["/demo/", "/transactions/add/", "/payment/"];

    for (const pattern of hideStartsWith) {
      if (currentPath.startsWith(pattern)) {
        return true;
      }
    }

    // Check for routes that contain certain patterns
    const hideContains = ["/checkout", "/billing"];

    for (const pattern of hideContains) {
      if (currentPath.includes(pattern)) {
        return true;
      }
    }

    return false;
  };

  // Check if user has active subscription
  const hasSubscription = hasActiveSubscription(user);

  // Hide the floating button if on hidden route OR user doesn't have subscription
  const shouldHideFloatingButton = isRouteHidden() || !hasSubscription;

  return <ChatWindow hideFloatingButton={shouldHideFloatingButton} />;
};

export default ChatVisibilityController;
